module.exports = __webpack_public_path__ + "media/src/images/page02_zu_worksheet02-f61114ec9f9fb733a013a090438f754f.gif";